
import path from 'path-browserify';

import { IndexedFiles } from './object-fs';
import { MemfsJson } from './memfs-type';

export function toMemfsJson(files: IndexedFiles = {}, prefix: string = ''): MemfsJson {
	const filesArr = Object.keys(files)
		.map(filepath => {
			const file = files[filepath];
			if (!file || file.isFile !== true || typeof file.source !== 'string') return null;

			const newPath = path.join(prefix, filepath);
			return { [newPath]: file.source };
		})
		.filter(x => !!x);

	return Object.assign({}, ...filesArr);
}
